import { GET_ALL_CATEGORIES } from '../actions/item-category/type';

const initState = { categories: [], cat1s: [], cat2s: [], cat3s: [] };
export default function (state = initState, action) {
  switch (action.type) {
    case GET_ALL_CATEGORIES: {
      return { ...state, categories: action.payload };
    }
    default:
      return { ...state }
  }
}